import { buildPermission } from "common/utils/auth";
import { Header } from "portal/components/header/Header";
import { IconButton, Typography } from "@mui/material";
import { Page } from "portal/components/Page";
import {
  PermissionAction,
  PermissionDomain,
  PermissionResource,
} from "protos/portal/auth";
import { TractorForm } from "./TractorForm";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withAuthorizationRequired } from "portal/components/auth/WithAuthorizationRequired";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import React, { FC } from "react";

interface CreateTractorProps {}
export const _CreateTractor: FC<CreateTractorProps> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const setDefaultOnSerial =
    searchParams.get("setDefaultOnSerial") ?? undefined;

  return (
    <Page>
      <Header title={t("views.autotractor.equipment.tractors.newTractor")} />
      <div className="flex flex-col">
        <div className="flex gap-2">
          <IconButton color="info" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" className="my-auto">
            {t("views.autotractor.equipment.tractors.newTractor")}
          </Typography>
        </div>
        <TractorForm setDefaultOnSerial={setDefaultOnSerial} />
      </div>
    </Page>
  );
};

export const CreateTractor = withAuthorizationRequired(
  {
    or: [
      buildPermission(
        PermissionAction.update,
        PermissionResource.atk_equipment,
        PermissionDomain.customer
      ),
      buildPermission(
        PermissionAction.update,
        PermissionResource.atk_equipment,
        PermissionDomain.all
      ),
    ],
  },
  _CreateTractor
);
